export const stasticmsg=(msg: any,code: any)=>{

return(
<div className="per100">
			 <div className="search-title-bar">
                       	<div className="search-title">
			  Message Box
			</div>
			<a href="#" onClick={e => msgclose()} title="Profile">
			<div className="search-title-toggle" id="togglesearch">
			  X
			</div>
			</a>
	   	     </div>
		    <div className="Sikaamsgbody">
			<div className="Sikaamsginerbody">
			{msg} <br /> {code}
		        </div>
			<div className="Sikaamsginerbody" style={{height:'30px',paddingRight:'20px'}}>
			<span>
			 <a href="#" onClick={e => msgclose()} className="profile-items"  style={{float:'right',color:'ffffff'}}>OK</a>
			</span>
		        </div>
		    </div>
		
		</div>
);
}
export const msgclose=()=>{
 const Pdivr = document.getElementById('customemsgdiv') as HTMLElement;
		Pdivr.style.display = 'none';
	
}
